<template>
  <div class="form tab-content" id="pathway-simplified-cables">
    <v-layout column style="padding-right: 20px">
      <v-layout
        row
        justify-space-between
        align-center
        style="flex-wrap: nowrap"
      >
        <input-field
          value=""
          :label="$t('CableList')"
          size="large"
          inputType="group"
        />

        <v-btn
          @click="addCable"
          small
          icon
          text
          color="accent"
          class="ma-0"
          :disabled="
            readOnly || !cableTypeOptions || cableTypeOptions.length === 0
          "
        >
          <v-icon>add_circle</v-icon>
        </v-btn>
      </v-layout>

      <v-layout column>
        <div
          v-if="cables.length > 0"
          v-for="(cable, index) in cables"
          :key="index"
          style="padding: 10px 0 0 20px"
        >
          <v-card flat>
            <v-layout row align-center justify-space-around>
              <span>{{ $tc("Cable", 1) + " " + (index + 1) }}</span>
              <input-field
                v-model="cables[index]"
                label=""
                input-type="select"
                size="medium"
                select-options="list_cable_owner_type"
                :placeholder="$t('SelectCableType')"
                :field-disabled="readOnly"
                :clearable="false"
              />
              <v-btn
                @click="removeCable(index)"
                small
                icon
                text
                color="accent"
                class="ma-0"
                :disabled="readOnly"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-layout>
          </v-card>
        </div>

        <v-layout
          v-if="cables.length === 0"
          align-center
          justify-center
          class="pa-3"
        >
          {{ $t("NoPathwaySimplifiedCables") }}
        </v-layout>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import InputField from "@/components/Home/Forms/_Molecules/InputField";

export default {
  name: "PathwaySimplifiedCables",

  components: { InputField },

  props: {
    originalCables: {
      type: String | null,
      required: true
    },
    readOnly: {
      type: Boolean
    }
  },

  data() {
    return {
      cables: [],

      cableTypeOptions: []
    };
  },

  created() {
    this.loadCableTypeOptions();
  },

  mounted() {
    this.parseOriginalCables();
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    parseOriginalCables() {
      if (typeof this.originalCables === "string") {
        let originalCables = JSON.parse(this.originalCables);
        if (typeof originalCables === "object") {
          this.cables = originalCables;
        }
      }
    },

    addCable() {
      let newCable = this.cableTypeOptions[0].code;
      this.cables.push(newCable);
    },

    removeCable(index) {
      this.cables.splice(index, 1);
    },

    loadCableTypeOptions() {
      let listName = "list_cable_owner_type";
      this.cableTypeOptions = this.$store.getters.getListOfOptionsByListName(
        listName
      );
      if (this.cableTypeOptions === undefined) {
        this.GET_LIST({ listName: listName })
          .then(list => {
            this.cableTypeOptions = list;
          })
          .catch(() => {
            this.cableTypeOptions = [];
          });
      }
    }
  },

  watch: {
    originalCables() {
      this.parseOriginalCables();
    },

    cables: {
      handler() {
        let cablesToSend = JSON.stringify(this.cables);
        this.$emit("updateValue", cablesToSend);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/PathwaySimplifiedCables.vue